/* Framework modules */
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProgressSpinnerModule } from 'primeng/progressspinner';

/* Application modules */
import { PublicRoutingModule } from "./public-routing.module";
import { SharedModule } from "../shared/modules/shared.module";
/* Application components */
import { PublicComponent } from "./public.component";
import { LandingComponent } from "./landing/landing.component";
import { HeaderComponent } from "./layout-views/header/header.component";
import { LoginComponent } from "./auth/login/login.component";
import { LoginModalComponent } from "./layout-views/login-modal/login-modal.component";
import { SignupComponent } from "./auth/signup/signup.component";
import { SignupConfirmationComponent } from "./auth/signup-confirmation/signup-confirmation.component";
import { FooterComponent } from "./layout-views/footer/footer.component";
import { PortCalenderComponent } from "./landing/partials/portcalender/port-calender.component";
import { InnerHeaderComponent } from "./landing/inner-header/inner-header.component";
import { SearchResultComponent } from "./landing/search-result/search-result.component";
import { PortfullcalendarComponent } from "./portfullcalendar/portfullcalendar.component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UploadCsvComponent } from './landing/upload-csv/upload-csv.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { RateRequestComponent } from './raterequest/rate-request/rate-request.component';
import { RateRequestListComponent } from './raterequest/rate-request-list/rate-request-list.component';
import { VoyageDetailComponent } from './voyage/voyage-detail/voyage-detail.component';
import { BookingDetailComponent } from './voyage/booking-detail/booking-detail.component';
import { BookingDetailslistComponent } from './voyage/booking-detailslist/booking-detailslist.component';
import { PlanselectionComponent } from './auth/planselection/planselection.component';
// import { DeviceDetectorModule } from "ngx-device-detector";
import { VoyagePerformanceComponent } from './landing/ShippingLinePerformance/voyage-performance/voyage-performance.component';
import { VoyagePerformanceLevel2Component } from './landing/ShippingLinePerformance/voyage-performance-level2/voyage-performance-level2.component';
import { VoyagePerformanceLevel3Component } from './landing/ShippingLinePerformance/voyage-performance-level3/voyage-performance-level3.component';
import { PortListComponent } from './admin/Ports/port-list/port-list.component';
import { PlanListComponent } from './admin/plans/plan-list/plan-list.component';
import { VesselsListComponent } from './admin/Vessels/vessels-list/vessels-list.component';
import { UserListComponent } from './admin/User/user-list/user-list.component';
import { CookiespolicyComponent } from './cookiespolicy/cookiespolicy.component';
import { TermsandconditionsComponent } from './termsandconditions/termsandconditions.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ServicesComponent } from './services/services.component';
import { VoyagePerformanceLevel4Component } from './landing/ShippingLinePerformance/voyage-performance-level4/voyage-performance-level4.component';
import { TrackingComponent } from './Tracking/tracking/tracking.component';
import { TrackingListComponent } from './Tracking/tracking-list/tracking-list.component';
import { FrightquotationComponent } from './frightquotation/frightquotation.component';
import { VerificationErrorComponent } from './layout-views/verification-error/verification-error.component';
// import {AgmCoreModule} from '@agm/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { APIListComponent } from "./admin/APIs/api-list/api-list.component";
import { TradeAndPortIntelligenceComponent } from "./landing/ShippingLinePerformance/trade-and-port-intelligence/trade-and-port-intelligence.component";
import { NewsComponent } from "./news/news.component";
import { ShippingLinesComponent } from './admin/shippinglines/shippinglines.component';
// import { Ng5SliderModule } from "ng5-slider";
import { LandingFeaturesComponent } from './landing/landing-features/landing-features.component';

// GLS Changes
import { ThreeHeaderComponent } from './landing/three-header/three-header.component';
import { NavigationComponent } from './landing/navigation/navigation.component';
import { LandingSplashComponent } from './landing/search-result-splash/search-result-splash.component';
import { StoreModule } from "@ngrx/store";
import { userReducer } from "../store/user/user.reducer";
import { VoyageTrackerSplash } from './voyagetrackersplash/voyagetrackersplash.component';
import { VoyageTrackerComponent } from './voyagetracker/voyagetracker.component';
import { PortcalendarSplashComponent } from './portcalendarsplash/portcalendarsplash.component';
import { OpenSearchComponent } from "./admin/open-searches/open-searches.component";
// import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { ScheduleComponent } from "./schedule/schedule.component";
import { AnalyticsComponent } from './analytics/analytics.component';
import { MyRateRequestListComponent } from './raterequest/my-rate-request/my-rate-request.component';
import { EnquirySidebarComponent } from "./enquiry-sidebar/enquiry-sidebar.component";


// const cookieConfig:NgcCookieConsentConfig = {
//   cookie: {
//     domain: window.location.hostname
//   },
//   palette: {
//     popup: {
//       background: '#000'
//     },
//     button: {
//       background: '#f1d600'
//     }
//   },
//   theme: 'edgeless',
//   type: 'info',
//   layout: 'my-custom-layout',
//   layouts: {
//     "my-custom-layout": '{{messagelink}}{{buttons}}'
//   },
//   elements:{
//     buttons: `
//     <div class="cc-compliance cc-highlight">
//     <a aria-label="deny cookies" role="button" tabindex="0" style='display:none' 
//     class="cc-btn cc-deny">Decline</a>
//     <a aria-label="allow cookies" role="button" tabindex="0" id="cc-btn" class="cc-btn cc-allow">Allow cookies</a>
//     </div>
//     `,  
//     messagelink: `
//     <span id="cookieconsent:desc" class="cc-message">{{message}} 
//       <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="cookiespolicy" target="_blank">{{cookiePolicyLink}}</a>, 
//       <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="privacypolicy" target="_blank">{{privacyPolicyLink}}</a> and our 
//       <a aria-label="learn more about our terms of service" tabindex="2" class="cc-link" href="termsandconditions" target="_blank">{{tosLink}}</a>
//     </span>
//     `,
//   },
//   content:{
//     message: 'By using our site, you acknowledge that you have read and understand our ',
    
//     cookiePolicyLink: 'Cookie Policy',
//     cookiePolicyHref: window.location.origin+'/cookiespolicy',
 
//     privacyPolicyLink: 'Privacy Policy',
//     privacyPolicyHref: window.location.origin+'/privacypolicy',
 
//     tosLink: 'Terms of Service',
//     tosHref: window.location.origin+'/termsandconditions',
//   }
// };

@NgModule({
  imports: [
    CommonModule,
    PublicRoutingModule,
    SharedModule,
    NgbModule,
    ProgressSpinnerModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    // DeviceDetectorM odule.forRoot()   ,
    // AgmCoreModule.forRoot({
    //   apiKey:"AIzaSyCWfmjf2QBX4dUMieMagLQ-9eWFIX8EgHs"
    //  }),
    GoogleMapsModule,
    StoreModule.forRoot({ user: userReducer }),
    // NgcCookieConsentModule.forRoot(cookieConfig)

   // IonicModule.forRoot(),

    // Ng5SliderModule
  ],
  declarations: [
    PublicComponent,
    LandingComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    SignupComponent,
    SignupConfirmationComponent,
    PortCalenderComponent,
    PortfullcalendarComponent,
    InnerHeaderComponent,
    SearchResultComponent,
    UploadCsvComponent, ForgotPasswordComponent,
    ResetPasswordComponent, RateRequestComponent,
    RateRequestListComponent, VoyageDetailComponent,
    BookingDetailComponent, BookingDetailslistComponent,
    PlanselectionComponent, VoyagePerformanceComponent,
    VoyagePerformanceLevel2Component, VoyagePerformanceLevel3Component,
    PortListComponent, PlanListComponent, VesselsListComponent,
    UserListComponent, CookiespolicyComponent, TermsandconditionsComponent,
    PrivacypolicyComponent, AboutusComponent, ServicesComponent,
    VoyagePerformanceLevel4Component, TrackingComponent, TrackingListComponent,
    FrightquotationComponent,VerificationErrorComponent, APIListComponent,
    TradeAndPortIntelligenceComponent, NewsComponent, ShippingLinesComponent,
    //UploadCsvComponent, ForgotPasswordComponent, ResetPasswordComponent, RateRequestComponent, RateRequestListComponent, VoyageDetailComponent, BookingDetailComponent, BookingDetailslistComponent, PlanselectionComponent, VoyagePerformanceComponent, VoyagePerformanceLevel2Component, VoyagePerformanceLevel3Component, PortListComponent, PlanListComponent, VesselsListComponent, UserListComponent, CookiespolicyComponent, TermsandconditionsComponent, PrivacypolicyComponent, AboutusComponent, ServicesComponent, VoyagePerformanceLevel4Component, TrackingComponent, TrackingListComponent,
    LoginModalComponent,
    ThreeHeaderComponent,
    NavigationComponent,
    LandingFeaturesComponent,
    LandingSplashComponent,
    VoyageTrackerSplash,
    ScheduleComponent,
    VoyageTrackerComponent,
    PortcalendarSplashComponent,
    OpenSearchComponent,
    AnalyticsComponent,
    MyRateRequestListComponent
  ]
})
export class PublicModule {
  static forRoot(): ModuleWithProviders<PublicModule> {
    return {
      ngModule: PublicModule,
      providers: [
        // UniqueDeviceID
      ]
    };
  }
}
